<template>
  <div class="wrapper clickable" @click="displayMedia(true)">
    <b-img :src="preview" class="cover" fluid/>
    <div class="icon">
      <i class="fas fa-image fa-3x"></i>
    </div>

    <b-modal v-model="showModal"
             :title="imageName"
             centered
             size="lg"
             hide-footer>
      <b-img :src="url" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  computed: {
    preview () {
      if (this.item.media[0] && this.item.media[0].thumbnail) {
        return this.item.media[0].thumbnail.url
      } else if (this.item.media[0]) {
        return this.item.media[0].url
      } else {
        return ''
      }
    },
    url () {
      if (this.item.media[0]) {
        return this.item.media[0].url
      } else {
        return ''
      }
    },
    imageName () {
      if (this.item.media[0] && this.item.media[0].name) {
        return this.item.media[0].name
      } else {
        return ''
      }
    }
  },
  methods: {
    displayMedia (show) {
      this.showModal = show
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';

.wrapper {
  height: 8rem;
  width: 15rem;
  position: relative;
  overflow: hidden;
  margin-right: $spacing-sm;
  flex: 0 0 auto;
  justify-content:center;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 0.25rem;
}

div.wrapper img {
  position: relative;
  top: -1px;
  left: -1px;
}

.cover {
  object-fit: cover;
  width: 15rem;
  height: 8rem;
}

.icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate( -50%, -50% );
  color: $medium-grey;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/image.vue